import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";

const License: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", size = 24, ...rest }, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
   <rect x="5.5" y="5.4375" width="13" height="13.8125" rx="1" stroke={color} strokeWidth="2" strokeLinecap="round" />
   <path d="M16.0898 3.75L16.0898 6.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
   <path d="M12 3.75L12 6.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
   <path d="M7.91016 3.75L7.91016 6.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
   <path d="M9 15C12.6522 15 13.8551 15 14 15" stroke={color} strokeWidth="2" strokeLinecap="round" />
   <path d="M9 11C13.3826 11 14.8261 11 15 11" stroke={color} strokeWidth="2" strokeLinecap="round" />   
</svg>);
export default License;